import { render, staticRenderFns } from "./CampaignInsights.vue?vue&type=template&id=1d002bc2&scoped=true&"
import script from "./CampaignInsights.vue?vue&type=script&lang=ts&"
export * from "./CampaignInsights.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignInsights.vue?vue&type=style&index=0&id=1d002bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d002bc2",
  null
  
)

export default component.exports